import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M22,20H21V8h1a1,1,0,0,0,0-2H21V3a1,1,0,0,0-1-1H4A1,1,0,0,0,3,3V6H2A1,1,0,0,0,2,8H3V20H2a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2Zm-7,0H9V16.47a6.21,6.21,0,0,1,3-5.33,6.21,6.21,0,0,1,3,5.33Zm4,0H17V16.47a8.17,8.17,0,0,0-4.55-7.36,1,1,0,0,0-.9,0A8.17,8.17,0,0,0,7,16.47V20H5V8H19ZM19,6H5V4H19Z" }, null, -1)
  ])))
}
export default { render: render }